import { HISTORY_BYBIT_COLUMNS_TO_OMIT } from '@/core/config/history'
import { ExchangeHistoryItemInterface } from '@/redux/transactions/transactions.types'
import { ByBitTransactionHistory } from '@/services/bybit'
import { dateFormatter, tryNumberFormatter } from '@/ui/organisms/HistoryTrade/HistoryTrade.utils/utils'

const bybitHistoryFormattres: Partial<Record<keyof ByBitTransactionHistory, Function>> = {
  transactionTime: (source: string) => dateFormatter(source),
  type: (source: string) => source,
}

export const bybitHistoryToHistoryItem = (source: ByBitTransactionHistory): ExchangeHistoryItemInterface => {
  const cloned: Record<string, string> = { ...source }

  Object.entries(cloned).forEach(([key, value]) => {
    if (value === undefined || value === '') {
      delete cloned[key as keyof ByBitTransactionHistory]
    }
  })

  return Object.keys(cloned).reduce((acc, key) => {
    if (HISTORY_BYBIT_COLUMNS_TO_OMIT.includes(key as keyof ByBitTransactionHistory)) return acc
    const formatter = bybitHistoryFormattres[key as keyof ByBitTransactionHistory]
    return {
      ...acc,
      ...(formatter ? { [key]: formatter(cloned[key]) } : { [key]: tryNumberFormatter(cloned[key]) }),
    }
  }, {})
}
